import React, { Component } from "react";
import { Link } from "react-router-dom";
import EnquiryFormModal from "./EnquiryFormModal";
class ExploreRange extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: "SUV",
            enquiryOpen: false,
        };
    }

    render() {
        const { activeTab } = this.state;

        const carData = {
            SUV: [
                {
                    name: "SELTOS",
                    image:
                        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fseltos.avif?alt=media&token=571bd65b-651c-49b3-8ede-e97ed5c0993a",
                    price: "₹ 10.99 Lakh*",
                    desc:
                        "Bolder, bigger, and unmistakably badass, The all-new Seltos commands attention with muscular design and confident comfort.",
                    link: "/newseltos",
                },

                {
                    name: "SONET",
                    image:
                        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fsonet.avif?alt=media&token=3e494dad-c44e-4c25-96da-43d4d707a850",
                    price: "₹ 7.31 Lakh*",
                    desc:
                        "Untamed by design, the new Kia Sonet unleashes raw power, bold style, and smart tech.",
                    link: "/sonet",
                },

                {
                    name: "SYROS",
                    image:
                        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fsuv_syros.avif?alt=media&token=53f06690-20aa-466b-9aad-6720d9868df3",
                    price: "₹ 8.39 Lakh*",
                    desc:
                        "The new Kia Syros blends futuristic design, smart technology, and bold innovation.",
                    link: "/syros",
                },

                {
                    name: "SORENTO",
                    image:
                        "https://www.kia.com/content/dam/kia2/in/en/our-vehicles/sorento/Kia-Sorento-Car-600x300.png",
                    price: "₹ 27.99 Lakh*",
                    desc:
                        "The global icon reimagined for India, with Hybrid, AWD and ADAS Level 2+.",
                    link: "/sorento",
                },
            ],

            MPV: [
                {
                    name: "CARENS CLAVIS",
                    image:
                        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fcarens-clavis.avif?alt=media&token=1a377155-b865-4f55-a0e9-87b2adf55180",
                    price: "₹ 11.20 Lakh*",
                    desc:
                        "Inspired by the Golden Key, the Carens Clavis unlocks epic family journeys.",
                    link: "/carens-clavis",
                },

                {
                    name: "CARENS",
                    image:
                        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fcarens1.avif?alt=media&token=8fa66c98-8f14-4d5d-85d7-312e75f51e9e",
                    price: "₹ 10.99 Lakh*",
                    desc:
                        "The Kia Carens commands attention with bold attitude and space-age sophistication.",
                    link: "/carens",
                },

                {
                    name: "CARNIVAL",
                    image:
                        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fcarnival.avif?alt=media&token=22bfdbc1-1a0e-4a5f-96d4-7a5a468d38ca",
                    price: "₹ xxx.xxx ",
                    desc:
                        "The new Carnival Limousine elevates every journey into pure comfort and opulence.",
                    link: "/carnival",
                },
            ],

            EV: [
                {
                    name: "CARENS CLAVIS EV",
                    image:
                        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fcarens-clavis-ev.avif?alt=media&token=f9bfa295-2ce4-473f-a0cd-d4abc241cdf4",
                    price: "₹ 17.99 Lakh*",
                    desc:
                        "Made for the family, the Carens Clavis EV brings comfort and technology together.",
                    link: "/carens-clavis-ev",
                },

                {
                    name: "EV6",
                    image:
                        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fev6.avif?alt=media&token=c6f607aa-bdcb-4c22-8f2c-04e5429aade9",
                    price: "₹ xxx.xx",
                    desc:
                        "A futuristic driver-centric cockpit with sustainable luxury and innovation.",
                    link: "/ev6",
                },

                {
                    name: "EV9",
                    image:
                        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/model%2Fev9.avif?alt=media&token=8f7f3f13-aae5-4662-a42d-c46c8523f123",
                    price: "₹ xx.xxx",
                    desc:
                        "The Kia EV9 redefines electric mobility with expansive space and futuristic comfort.",
                    link: "/ev9",
                },
            ],
        };

        return (
            <div
                style={{
                    width: "100%",
                    padding:
                        window.innerWidth <= 768
                            ? "40px 15px"
                            : "70px 40px",

                    background: "#f3f3f3",
                    boxSizing: "border-box",
                }}
            >
                {/* HEADING */}
                <h1
                    style={{
                        textAlign: "center",
                        fontSize:
                            window.innerWidth <= 768
                                ? "38px"
                                : "58px",

                        marginBottom: "40px",

                        fontWeight: "800",
                        color: "#000",
                    }}
                >
                    Explore The Range
                </h1>

                {/* TABS */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "14px",
                        marginBottom: "50px",
                        flexWrap: "wrap",
                    }}
                >
                    {["SUV", "MPV", "EV"].map((tab) => (
                        <button
                            key={tab}
                            onClick={() =>
                                this.setState({ activeTab: tab })
                            }
                            style={{
                                padding:
                                    window.innerWidth <= 768
                                        ? "12px 26px"
                                        : "14px 34px",

                                border: "none",
                                cursor: "pointer",

                                background:
                                    activeTab === tab
                                        ? "#001f32"
                                        : "#d9d9d9",

                                color:
                                    activeTab === tab
                                        ? "#fff"
                                        : "#000",

                                fontWeight: "600",

                                fontSize:
                                    window.innerWidth <= 768
                                        ? "14px"
                                        : "16px",

                                transition: "0.3s",
                            }}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* CARDS */}
                <div
                    style={{
                        display: "grid",

                        gridTemplateColumns:
                            window.innerWidth <= 768
                                ? "1fr"
                                : "repeat(3,1fr)",

                        gap: "28px",
                    }}
                >
                    {carData[activeTab].map((car, index) => (
                        <div
                            key={index}
                            style={{
                                background: "#dcdcdc",
                                padding: "20px",
                                boxSizing: "border-box",
                            }}
                        >
                            {/* IMAGE */}
                            <img
                                src={car.image}
                                alt={car.name}
                                style={{
                                    width: "100%",

                                    height:
                                        window.innerWidth <= 768
                                            ? "240px"
                                            : "240px",

                                    objectFit: "contain",
                                }}
                            />

                            {/* NAME */}
                            <h2
                                style={{
                                    textAlign: "center",
                                    marginTop: "20px",
                                    marginBottom: "10px",

                                    fontSize:
                                        window.innerWidth <= 768
                                            ? "26px"
                                            : "30px",

                                    fontWeight: "800",
                                }}
                            >
                                {car.name}
                            </h2>

                            {/* PRICE */}
                            <h3
                                style={{
                                    textAlign: "center",
                                    color: "#c8102e",
                                    marginBottom: "16px",

                                    fontSize:
                                        window.innerWidth <= 768
                                            ? "18px"
                                            : "20px",
                                }}
                            >
                                {car.price}
                            </h3>

                            {/* DESCRIPTION */}
                            <p
                                style={{
                                    textAlign: "center",
                                    color: "#555",

                                    lineHeight:
                                        window.innerWidth <= 768
                                            ? "28px"
                                            : "30px",

                                    fontSize:
                                        window.innerWidth <= 768
                                            ? "17px"
                                            : "18px",

                                    marginBottom: "30px",
                                }}
                            >
                                {car.desc}
                            </p>

                            {/* BUTTON */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <button
                                    onClick={() =>
                                        this.setState({
                                            enquiryOpen: true,
                                        })
                                    }
                                    style={{
                                        background: "#c8102e",
                                        color: "#fff",
                                        border: "none",

                                        padding:
                                            window.innerWidth <= 768
                                                ? "10px 25px"
                                                : "10px 25px",

                                        cursor: "pointer",

                                        fontSize:
                                            window.innerWidth <= 768
                                                ? "14px"
                                                : "15px",

                                        fontWeight: "600",
                                    }}
                                >
                                    Enquiry Now
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
                <EnquiryFormModal
                    open={this.state.enquiryOpen}
                    onClose={() =>
                        this.setState({
                            enquiryOpen: false,
                        })
                    }
                />
            </div>
        );
    }
}

export default ExploreRange;